import moment from 'moment';
import { DEVICE_TYPES } from "../../../common/constant/common-constants";
import blackDownArrow from "../../../common/icons/svg/black-down-arrow.svg";
import blackUpArrow from "../../../common/icons/svg/black-up-arrow.svg";
import whiteUpArrow from "../../../common/icons/svg/white-up-arrow.svg";
import whiteDownArrow from "../../../common/icons/svg/white-down-arrow.svg";
import './DeviceTabMobileView.scss'

function DeviceTabMobileView({
    activeVitalDevice,
    deviceAlarmData,
    showMoreAlarms_1,
    showMoreAlarms_2,
    handleShowMoreAlarmsClick_1,
    handleShowMoreAlarmsClick_2,
    handleSeeAllAlarms,
    getAlarmPriorityClass
}) {

    const isHighPriority = (alarm) =>
        alarm?.priority?.toLocaleUpperCase() === "HIGH";

    const renderAlarmBar = ({
        alarms,
        isOpen,
        onToggle,
        idAttr,
        messageKey,
        timeFormat,
    }) => {
        if (!alarms?.length) return null;

        const head = alarms[0];

        return (
            <div
                className={`alarm-container ${getAlarmPriorityClass(head)}`}
                onClick={onToggle}
                id={idAttr}
            >
                <div className="top-alarm-container">
                    {head?.[messageKey]}

                    <div className="alarm-number-container">
                        {alarms.length}
                        <img
                            src={
                                isOpen
                                    ? (isHighPriority(head) ? whiteUpArrow : blackUpArrow)
                                    : (isHighPriority(head) ? whiteDownArrow : blackDownArrow)
                            }
                            className="arrow-icon"
                            alt="accordion arrow"
                        />
                    </div>
                </div>

                {isOpen &&
                    <div className="more-alarm-container">
                        {alarms.map((alarm, count) => {
                            if (count > 3) return null;
                            return (
                                <div className="alarm more-alarm" key={count}>
                                    <div style={{ display: 'inline-flex', width: '70%', height: '100%', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                        <img
                                            src={`/assets/icons/alarm/${getAlarmPriorityClass(alarm)}-alarm.png`}
                                            style={{ width: '15px', height: '15px', marginRight: '2px' }}
                                            alt="alarm icon"
                                        />
                                        {alarm[messageKey].slice(0, 15)}{alarm[messageKey].length > 15 ? '...' : ''}
                                    </div>
                                    <div className="alarm-time">
                                        {alarm.time && (
                                            timeFormat
                                                ? moment(alarm.time, timeFormat).format("HH:mm:ss")
                                                : moment(alarm.time).format("HH:mm:ss")
                                        )}
                                    </div>
                                </div>
                            );
                        })}

                        <div className="see-all-container" onClick={handleSeeAllAlarms}>
                            See all
                        </div>
                    </div>
                }
            </div>
        );
    };

    return (
        <div className='machine-tabs-wrap-mobile-view'>
            {activeVitalDevice === DEVICE_TYPES['NOCCARC_PM_NX5'] ? (
                <div className="patient-monitor-alarm-mobile">
                    <div className="mode-container-mobile">
                        {renderAlarmBar({
                            alarms: deviceAlarmData?.alarms_physiological,
                            isOpen: showMoreAlarms_1,
                            onToggle: handleShowMoreAlarmsClick_1,
                            idAttr: "alarm-display-bar-1",
                            messageKey: "message",
                        })}
                    </div>

                    <div className="mode-container-mobile">
                        {renderAlarmBar({
                            alarms: deviceAlarmData?.alarms__technical,
                            isOpen: showMoreAlarms_2,
                            onToggle: handleShowMoreAlarmsClick_2,
                            idAttr: "alarm-display-bar-2",
                            messageKey: "message",
                        })}
                    </div>
                </div>
            ) : (
                renderAlarmBar({
                    alarms: deviceAlarmData,
                    isOpen: showMoreAlarms_1,
                    onToggle: handleShowMoreAlarmsClick_1,
                    idAttr: "alarm-display-bar-1",
                    messageKey: "name",
                    timeFormat: "YYYYMMDDHHmmss",
                })
            )}
        </div>
    );
}

export default DeviceTabMobileView;
